import { Row, Col, Form, Card } from 'react-bootstrap'
import Select from 'react-select'
import { useAdminMunicipalityOptions } from 'api/hooks/use-admin-municipalities'

const MONTH_OPTIONS = Array.from({ length: 18 }, (_, i) => i + 1)

const AnalyticsDateFilter = ({
  months,
  grouping,
  municipalityIds = [],
  onMonthsChange,
  onGroupingChange,
  onMunicipalityChange
}) => {
  // Municipality filtering only makes sense for cross-municipality views (the
  // analytics dashboard). Single-user pages omit onMunicipalityChange.
  const showMunicipalityFilter = Boolean(onMunicipalityChange)
  const { data: municipalities = [], isLoading } = useAdminMunicipalityOptions()

  const options = municipalities.map((m) => ({ value: m.id, label: m.name }))
  const selected = options.filter((o) => municipalityIds.includes(o.value))

  return (
    <Card className="mb-4">
      <Card.Body>
        <Row className="align-items-end">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Time Range</Form.Label>
              <Form.Select
                value={months}
                onChange={(e) => onMonthsChange(Number(e.target.value))}
              >
                {MONTH_OPTIONS.map((m) => (
                  <option key={m} value={m}>
                    {m === 1 ? 'Last month' : `Last ${m} months`}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Group By</Form.Label>
              <Form.Select
                value={grouping}
                onChange={(e) => onGroupingChange(e.target.value)}
              >
                <option value="day">Day</option>
                <option value="week">Week</option>
                <option value="month">Month</option>
              </Form.Select>
            </Form.Group>
          </Col>
          {showMunicipalityFilter && (
            <Col md={6}>
              <Form.Group>
                <Form.Label>Municipalities</Form.Label>
                <Select
                  isMulti
                  options={options}
                  value={selected}
                  isLoading={isLoading}
                  placeholder="All municipalities"
                  classNamePrefix="react-select"
                  onChange={(vals) =>
                    onMunicipalityChange((vals || []).map((v) => v.value))
                  }
                />
              </Form.Group>
            </Col>
          )}
        </Row>
      </Card.Body>
    </Card>
  )
}

export default AnalyticsDateFilter
